import React from 'react';
import { useRecordContext } from 'react-admin';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const DiameterEnterButton = (props: any) => {
  const record: any = useRecordContext(props);
  const navigate = useNavigate();

  function openDiameter() {
    navigate(`/diameters/${record.id}`);
  }

  return (
    <>
      <IconButton onClick={() => openDiameter()}>
        <ArrowRightAltIcon />
      </IconButton>
    </>
  );
};
